import React, { useState, useEffect, useCallback } from "react";
import { fetchSamples } from "../Utils/SamplesFetch";
import { PrimaryHeading, HeaderLink } from "../trending/Theme";
import Samples from "../Samples";
import { fetchGraphs } from "../../../lib/fetching/FetchGraphs";
import FolderBrowser from "../trending/FolderBrowser";

export default function ChartNavigator({ product_id, measurement_ids, searchParams }) {
  const [folder, setFolder] = useState(null);
  const [sampleList, setSampleList] = useState(null);
  const [loadingSamples, setLoadingSamples] = useState(false);

  const company_id = searchParams.company_ids[0];

  const clearSample = () => setSampleList(null);

  const findSamples = useCallback(({ sample_ids }) => {
    setLoadingSamples(true);
    fetchSamples({
      sample_ids
    }).then(sampleList => {
      setLoadingSamples(false);
      setSampleList(null);
      setSampleList(sampleList);
    });
  }, []);

  const renderSampleContainer = () => (
    <div style={{ marginTop: 20, opacity: loadingSamples || !sampleList ? 0.5 : 1 }}>
      <PrimaryHeading>
        Samples
        {sampleList && <HeaderLink onClick={clearSample}>Clear Samples</HeaderLink>}
      </PrimaryHeading>
      <Samples
        sample_list={sampleList}
        company_id={company_id}
        showAttributes={false}
        clientView={true}
      />
    </div>
  );

  React.useEffect(() => {
    const params = {
      company_id: company_id,
      start_date_f: searchParams.start_date,
      end_date_f: searchParams.end_date,
      company_branch_ids: searchParams.company_branch_ids,
      product_ids: [product_id],
      test_name_ids: measurement_ids,
      data_field_query_params: searchParams.data_fields,
      client_suite_id: searchParams.client_suite_id
    };
    fetchGraphs(params).then(json => {
      if (json.errors) {
        alert(json.errors);
        return;
      }

      // set the root folder to the single product folder
      const rootFolder = json.folder.folders.find(folder => folder.id === "products")
        .folders[0];
      rootFolder.expanded = true;

      setFolder(rootFolder);
    });
  }, []);

  if (!folder) return <div>Loading...</div>;

  return (
    <div style={{ marginLeft: 20, marginRight: 20, marginBottom: 10 }}>
      {sampleList && renderSampleContainer()}
      <FolderBrowser folder={folder} findSamples={findSamples} simpleView={true} />
    </div>
  );
}
